var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGateioDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31156 7.00122C3.31156 9.12629 5.03558 10.8503 7.16064 10.8503C9.28571 10.8503 11.0097 9.12873 11.0097 7.00122H14.1594C14.1594 10.865 11.0244 14 7.16064 14C3.29444 14 0.161865 10.8674 0.161865 7.00122C0.161865 3.13502 3.29444 0 7.16064 0L7.16064 3.1521H11.0097V7.00118H7.16064L7.16064 3.15214C5.03558 3.15214 3.31156 4.87616 3.31156 7.00122Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateioDark);
export default __webpack_public_path__ + "static/media/gateioDark.1a68d1ef1cf790ac922a1226dd481ac6.svg";
export { ForwardRef as ReactComponent };